import React, { useState, useEffect } from "react";
import { Button, FormControl, TextField } from "@material-ui/core";
import "../../../styles/banner.scss";
import config from "../../config/config";
import { Link } from "react-scroll";
import Modalpopup from "../../pages/Modalpopup/Modalpopup";
import CustomDrawer from "../../common/CustomDrawer/CustomDrawer";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Modalpopupcalquemarket from "../../landing/Modalpopups/Modalpopupcalquemarket";
import { useFormik } from "formik";
import { useGAEventsTracker } from "../../../util/gtag";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import ApplicationFunnel from "../../common/ApplicationFunnelWidget/ApplicationFunnel";
// import Chatbot from "../../common/chatbot/Chatbot";
export default function NewBanner(props) {
  const GAEventTracker = useGAEventsTracker(window.location.pathname);
  const GAEventTrackerGetStarted = useGAEventsTracker(
    window.location.pathname + "/Get Started"
  );
  const GAEventTrackerContactUs = useGAEventsTracker(
    window.location.pathname + "/Contact Us"
  );
  const [openSubmit, setOpenSubmit] = React.useState(false);
  const [openCalque, setOpenCalque] = useState(false);
  const [detail, setDetail] = React.useState("");
  const [validateUserInfo, setValidateUserInfo] = useState(false);
  const [severity_type, setSeverityType] = React.useState("");
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [errorsOut, seterrorsOut] = useState();
  const [openFailure, setOpenFailure] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [address, setAddress] = useState("");
  const [itemstype, setItemstype] = useState([]);
  const [gmapErr, setGmapErr] = useState(false);
  const history = useHistory();

  // useEffect(() => {
  //     const pathName = window.location.pathname; // Get current pathname
  //     if (pathName.includes('questionnaire')) {
  //         // props?.setCDrawerHome(true); // Set to true if the page includes "questionnaire"
  //     } else {
  //       // props?.setCDrawerHome(false); // Set to false for other paths
  //     }

  //     // Prevent back button navigation on questionnaire page
  //     window.history.pushState(null, null, window.location.href);
  //     window.onpopstate = function (event) {
  //         window.history.go(1); // Stay on the current page if the user hits the back button
  //     };
  // }, []);

  useEffect(() => {
    if (props?.partner?.url_path === "c2") {
      const h2Tags = document.querySelectorAll("h2");
      const h3Tags = document.querySelectorAll("h3");
      const h4Tags = document.querySelectorAll("h4");
      const h6Tags = document.querySelectorAll("h6");
      const pTags = document.querySelectorAll("p");
      const liTags = document.querySelectorAll("li");
      const spanTags = document.querySelectorAll("span");
      const a = document.querySelectorAll("a");
      h2Tags.forEach((h2) => {
        h2.classList.add("ftpolar-semibold");
      });
      h3Tags.forEach((h3) => {
        h3.classList.add("ftpolar-light");
      });
      h4Tags.forEach((h4) => {
        h4.classList.add("ftpolar-semibold");
      });
      h6Tags.forEach((h6) => {
        h6.classList.add("ftpolar-semibold");
      });
      pTags.forEach((p) => {
        p.classList.add("ftpolar-light");
      });
      liTags.forEach((li) => {
        li.classList.add("ftpolar-light");
      });
      spanTags.forEach((span) => {
        span.classList.add("ftpolar-light");
      });
      a.forEach((a) => {
        a.classList.add("ftpolar-light");
      });
    }
  }, [props?.partner?.url_path]);

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const vertical = "top";
  const horizontal = "center";
  const handleClickOpen2 = () => {
    setOpenSubmit(!openSubmit);
  };
  const handleZipCode = () => {
    props.setValidateControl(true);
    props.setDisplayError(true);
    let postData = {
      zip_code: props.values.property_address
        ? props.values.property_address.zip_code
        : null,
    };
    let authorise = process.env.REACT_APP_API_KEY;
    fetch(`${config.baseUrlCP}validate-zipcode/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `${authorise}`,
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate",
      },
      body: JSON.stringify(postData),
    })
      .then(async (response) => {
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          props.GAtimer();
          props.GAtimerFinish();
          if (results.is_operating_area === false) {
            setOpenCalque(true);
            props && props.setErrDisplay(false);
          } else {
            setOpenCalque(false);
            props.drawerHandleOpen();
            props.handleReset();
            props && props.setErrDisplay(false);
          }
          if (
            Object.keys(props.errors).length !== 0 &&
            props.errors.property_type == undefined &&
            props.errors.street_address == undefined
          ) {
            GAEventTracker("UserEnteredQuestionnaire", 1);
          }
        } else {
          setOpenCalque(false);
          props && props.setErrDisplay(false);
          setGmapErr(results.zip_code[0]);
        }
      })
      .catch((error) => {});
  };
  const handlePopupSubmit = (event) => {
    setValidateUserInfo(true);
    if (!event.detail || event.detail == 1) {
      return true;
    } else {
      event.preventDefault();
    }
  };
  const handleClickOpener = () => {
    setOpenCalque(!openCalque);
  };
  const onSubmit = (values) => {
    var postUserQue = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      location: props.values && props.values.property_address.street_address,
      partner_id: props?.partner?.partner_id ? props.partner.partner_id : null,
    };
    let authorise = process.env.REACT_APP_API_KEY;
    fetch(`${config.baseUrlCP}email-for-validate-zipcode/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `${authorise}`,
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate",
      },
      body: JSON.stringify(postUserQue),
    })
      .then(async (response) => {
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          setOpenSnackbar(true);
          setDetail(results.message);
          setSeverityType("success");
          setOpenSuccess(!openSuccess);
          setOpenSubmit(false);
          setValidateUserInfo(false);
          formik.setFieldValue("first_name", "");
          formik.setFieldValue("last_name", "");
          formik.setFieldValue("email", "");
          formik.setFieldValue("location", "");
          setOpenCalque(false);
        } else {
          if (results.detail) {
            setOpenSnackbar(true);
            setDetail(results.message);
            setSeverityType("error");
            setOpenFailure(!openFailure);
            setOpenSubmit(false);
            formik.setFieldValue("first_name", "");
            formik.setFieldValue("last_name", "");
            formik.setFieldValue("email", "");
            formik.setFieldValue("user_question", "");
            await sleep(2000);
          } else {
            setSeverityType("error");
          }
        }
      })
      .catch((error) => {
        setDetail("Something Went Wrong!");
        setSeverityType("error");
        setOpenSnackbar(true);
        setOpenSubmit(false);
      });
  };
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    location: "",
  };
  const validate = (values) => {
    let errors = {};

    if (values.first_name === "") {
      errors.first_name = "Please enter first name";
    }
    if (values.last_name === "") {
      errors.last_name = "Please enter last name";
    }
    if (values.email === "") {
      errors.email = "Please provide a valid Email Address";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Please provide a valid Email Address";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues,
    onSubmit,
    validate,
  });

  useEffect(() => {
    let isMounted = true;
    setTimeout(() => {
      if (isMounted) {
        seterrorsOut(props.errors);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [props.errors]);

  useEffect(() => {
    props.setSubmitSuccess(true);
  }, [props]);

  useEffect(() => {
    if (openSnackbar === true) {
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 2000);
    }
  }, [openSnackbar]);

  const handleGetStart = () => {
    GAEventTrackerGetStarted("Get started", 1);
    // Get the current URL
    const currentUrl = window.location.pathname;
    // Check if the URL ends with a slash, then append '/questionnaire'
    const newUrl = currentUrl.endsWith("/")
      ? `${currentUrl}questionnaire`
      : `${currentUrl}/questionnaire`;
      // Use pushState to change the URL without reloading the page
      //  window.history.pushState(null, "", newUrl);
    history.push(newUrl);
  };
  const IconUnlock = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
      <path d="M15 11V8C15 6 14 4 11.5 4C9 4 8 6 8 8"
        stroke="white" strokeWidth="2" fill="none" />
      <rect x="8" y="11" width="8" height="7" stroke="white" strokeWidth="2" />
    </svg>
  );

  const IconOffer = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
      <path d="M7 12L10 15L15 10" stroke="white" strokeWidth="2" fill="none" />
    </svg>
  );

  const IconTimeline = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
      <path d="M12 7V12L16 14"
        stroke="white" strokeWidth="2"
        strokeLinecap="round" />
    </svg>
  );

  const IconStressFree = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
      <path
        d="M7 12L10 15L15 10M5 10L9 14M18 9L14 13"
        stroke="white" strokeWidth="2"
        fill="none" />
    </svg>
  );

  const IconSecure = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
      <path d="M12 6L6 9V12C6 16 9 18 12 19C15 18 18 16 18 12V9L12 6Z"
        stroke="white" strokeWidth="2" fill="none" />
    </svg>
  );

  const IconHandshake = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="11" stroke="white" strokeWidth="2" />
      <path
        d="M7 12L10 15L15 10M5 10L9 14M18 9L14 13"
        stroke="white" strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
  const primaryColor = props.partner?.primary_color || "#83C547";
  const GrowthIcon = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="101" viewBox="0 0 100 101" fill="none">
      <rect width="100" height="101" fill="white" />
      <path d="M26.5625 50.5C39.5 50.5 50 39.895 50 26.8281C50 13.7613 39.5 3.15625 26.5625 3.15625C13.625 3.15625 3.125 13.7613 3.125 26.8281C3.125 39.895 13.625 50.5 26.5625 50.5ZM28.4375 29.9844H24.6875C20.9062 29.9844 17.8125 26.8597 17.8125 23.0406C17.8125 19.6319 20.25 16.8228 23.4688 16.2231V15.4656C23.4688 13.7297 24.875 12.3094 26.5938 12.3094C28.3125 12.3094 29.7188 13.7297 29.7188 15.4656V16.0969H32.25C33.9688 16.0969 35.375 17.5172 35.375 19.2531C35.375 20.9891 33.9688 22.4094 32.25 22.4094H24.7188C24.375 22.4094 24.0938 22.6934 24.0938 23.0406C24.0938 23.3878 24.375 23.6719 24.7188 23.6719H28.4687C32.25 23.6719 35.3438 26.7966 35.3438 30.6156C35.3438 34.0244 32.9062 36.8334 29.6875 37.4331V38.1906C29.6875 39.9266 28.2812 41.3469 26.5625 41.3469C24.8438 41.3469 23.4375 39.9266 23.4375 38.1906V37.5594H20.9062C19.1875 37.5594 17.7812 36.1391 17.7812 34.4031C17.7812 32.6672 19.1875 31.2469 20.9062 31.2469H28.4375C28.7813 31.2469 29.0625 30.9628 29.0625 30.6156C29.0625 30.2684 28.7813 29.9844 28.4375 29.9844Z" fill={props.partner.secondary_color ||"#83C547" }/>
      <path d="M93.75 91.5312H87.5V48.9219C87.5 44.5663 84 41.0312 79.6875 41.0312H73.4375C69.125 41.0312 65.625 44.5663 65.625 48.9219V91.5312H60.9375V61.5469C60.9375 57.1912 57.4375 53.6562 53.125 53.6562H46.875C42.5625 53.6562 39.0625 57.1912 39.0625 61.5469V91.5312H34.375V74.1719C34.375 69.8162 30.875 66.2812 26.5625 66.2812H20.3125C16 66.2812 12.5 69.8162 12.5 74.1719V91.5312H6.25C4.53125 91.5312 3.125 92.9516 3.125 94.6875C3.125 96.4234 4.53125 97.8438 6.25 97.8438H93.75C95.4688 97.8438 96.875 96.4234 96.875 94.6875C96.875 92.9516 95.4688 91.5312 93.75 91.5312ZM71.875 48.9219C71.875 48.0381 72.5625 47.3438 73.4375 47.3438H79.6875C80.5625 47.3438 81.25 48.0381 81.25 48.9219V91.5312H71.875V48.9219ZM45.3125 61.5469C45.3125 60.6631 46 59.9688 46.875 59.9688H53.125C54 59.9688 54.6875 60.6631 54.6875 61.5469V91.5312H45.3125V61.5469ZM18.75 74.1719C18.75 73.2881 19.4375 72.5938 20.3125 72.5938H26.5625C27.4375 72.5938 28.125 73.2881 28.125 74.1719V91.5312H18.75V74.1719Z" fill="#1B3964" />
    </svg>
);
const OnlineBusinessIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="106" height="105" viewBox="0 0 106 105" fill="none">
    <path d="M53 68.9062C67.6081 68.9062 79.5 57.1266 79.5 42.6562C79.5 28.1859 67.6081 16.4062 53 16.4062C38.3919 16.4062 26.5 28.1859 26.5 42.6562C26.5 57.1266 38.3919 68.9062 53 68.9062ZM55.1531 45.9375H50.8469C46.64 45.9375 43.2281 42.5578 43.2281 38.3906C43.2281 34.6172 46.0437 31.5328 49.6544 30.975V29.8922C49.6544 28.0875 51.145 26.6109 52.9669 26.6109C54.7887 26.6109 56.2794 28.0875 56.2794 29.8922V30.8766H59.3931C61.215 30.8766 62.7056 32.3531 62.7056 34.1578C62.7056 35.9625 61.215 37.4391 59.3931 37.4391H50.8138C50.2838 37.4391 49.82 37.8656 49.82 38.4234C49.82 38.9813 50.2506 39.4078 50.8138 39.4078H55.12C59.3269 39.4078 62.7388 42.7875 62.7388 46.9547C62.7388 50.7281 59.9231 53.8125 56.3125 54.3703V55.4531C56.3125 57.2578 54.8219 58.7344 53 58.7344C51.1781 58.7344 49.6875 57.2578 49.6875 55.4531V54.4688H46.5738C44.7519 54.4688 43.2613 52.9922 43.2613 51.1875C43.2613 49.3828 44.7519 47.9063 46.5738 47.9063H55.1531C55.6831 47.9063 56.1469 47.4797 56.1469 46.9219C56.1469 46.3641 55.7162 45.9375 55.1531 45.9375Z" fill={props.partner.secondary_color ||"#83C547" }/>
    <path d="M85.9595 29.8048C86.8538 29.8048 87.7482 29.479 88.4107 28.857L94.9363 22.5186C96.162 21.3042 96.0957 19.4383 94.7376 18.3424C93.3795 17.2465 91.2926 17.3057 90.067 18.5201L83.5413 24.8585C82.3157 26.0728 82.382 27.9388 83.7401 29.0347C84.3695 29.5678 85.1645 29.8048 85.9926 29.8048H85.9595Z" fill="#1B3964" />
    <path d="M72.7425 22.963C72.7425 22.963 72.8419 22.963 72.875 22.963C74.6969 22.9037 76.1213 21.5117 76.055 19.8826L75.8563 15.7064C75.79 14.0774 74.3325 12.863 72.4113 12.863C70.5894 12.9223 69.165 14.3143 69.2313 15.9434L69.43 20.1196C69.4963 21.719 70.9869 22.963 72.7425 22.963Z" fill="#1B3964" />
    <path d="M91.3919 38.1569C91.4582 39.7563 92.9488 41.0003 94.7044 41.0003C94.7376 41.0003 94.8038 41.0003 94.8369 41.0003L99.5076 40.8225C101.329 40.7633 102.754 39.3712 102.688 37.7422C102.621 36.1132 101.064 34.8692 99.2426 34.8988L94.5719 35.0765C92.7501 35.1358 91.3257 36.5279 91.3919 38.1569Z" fill="#1B3964" />
    <path d="M17.5896 28.857C18.2521 29.479 19.1464 29.8048 20.0408 29.8048C20.8358 29.8048 21.6308 29.5382 22.2933 29.0347C23.6514 27.9388 23.7177 26.0432 22.4921 24.8585L15.9664 18.5201C14.7408 17.3057 12.6208 17.2465 11.2958 18.3424C9.93768 19.4383 9.87143 21.3339 11.0971 22.5186L17.6227 28.857H17.5896Z" fill="#1B3964" />
    <path d="M33.1251 22.9627C33.1251 22.9627 33.2245 22.9627 33.2576 22.9627C35.0133 22.9627 36.5039 21.7187 36.5701 20.1193L36.7689 15.9431C36.8351 14.3141 35.4439 12.922 33.5889 12.8627C31.7339 12.8035 30.2101 14.0475 30.1439 15.7061L29.9451 19.8823C29.8789 21.5114 31.2701 22.9034 33.1251 22.9627Z" fill="#1B3964" />
    <path d="M6.49257 40.8226L11.1632 41.0003C11.1632 41.0003 11.2626 41.0003 11.2957 41.0003C13.0513 41.0003 14.5419 39.7563 14.6082 38.1569C14.6744 36.5279 13.2832 35.1358 11.4282 35.0766L6.75757 34.8988C4.9357 34.8692 3.37882 36.0836 3.31257 37.7422C3.24632 39.4009 4.63757 40.7633 6.49257 40.8226Z" fill="#1B3964" />
    <path d="M99.3751 83.7104H96.8907V53.3514C96.8907 48.8494 92.8163 45.2063 87.7813 45.2063C85.9594 45.2063 84.4688 46.5391 84.4688 48.1682C84.4688 49.7972 85.9594 51.13 87.7813 51.13C89.1394 51.13 90.2657 52.137 90.2657 53.3514V83.7104H15.7344V53.3514C15.7344 52.137 16.8607 51.13 18.2188 51.13C20.0407 51.13 21.5313 49.7972 21.5313 48.1682C21.5313 46.5391 20.0407 45.2063 18.2188 45.2063C13.1838 45.2063 9.10944 48.8494 9.10944 53.3514V83.7104H6.62506C4.80319 83.7104 3.31256 85.0433 3.31256 86.6723V93.5734C3.31256 98.0754 7.38694 101.719 12.4219 101.719H93.5782C98.6132 101.719 102.688 98.0754 102.688 93.5734V86.6723C102.688 85.0433 101.197 83.7104 99.3751 83.7104ZM96.0626 93.5734C96.0626 94.7878 94.9363 95.7948 93.5782 95.7948H12.4219C11.0638 95.7948 9.93756 94.7878 9.93756 93.5734V89.6341H96.0626V93.5734Z" fill="#1B3964" />
    <path d="M21.5313 74.8249C21.5313 76.4539 23.0219 77.7867 24.8438 77.7867H31.4688C33.2907 77.7867 34.7813 76.4539 34.7813 74.8249C34.7813 73.1959 33.2907 71.863 31.4688 71.863H24.8438C23.0219 71.863 21.5313 73.1959 21.5313 74.8249Z" fill="#1B3964" />
    <path d="M71.2188 74.8249C71.2188 76.4539 72.7094 77.7867 74.5313 77.7867H81.1563C82.9782 77.7867 84.4688 76.4539 84.4688 74.8249C84.4688 73.1959 82.9782 71.863 81.1563 71.863H74.5313C72.7094 71.863 71.2188 73.1959 71.2188 74.8249Z" fill="#1B3964" />
  </svg>
);
const RocketIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="106" height="107" viewBox="0 0 106 107" fill="none">
    <path d="M3.31265 100.012C3.21327 101.015 3.57765 101.985 4.27327 102.687C4.90265 103.322 5.73077 103.657 6.62515 103.657C6.72452 103.657 6.8239 103.657 6.92327 103.657C7.65202 103.59 21.7964 102.118 32.8933 90.6159L16.2314 73.7969C4.8364 84.9984 3.3789 99.2763 3.31265 100.012Z" fill={props.partner.secondary_color ||"#83C547" }/>
    <path d="M87.9468 47.9493C100.634 27.6193 102.588 8.25899 102.687 6.98837C102.787 5.98524 102.422 5.01556 101.727 4.31337C101.031 3.61118 100.071 3.24337 99.0768 3.34368C97.8181 3.444 78.6387 5.41681 58.4987 18.2234L40.7768 17.0865C36.0399 16.7856 31.3693 18.5577 28.0237 21.9684L12.3224 37.8177C11.3949 38.754 11.0968 40.1249 11.5606 41.3621C12.0243 42.5993 13.1506 43.4352 14.4425 43.5356L31.0381 44.7393C29.3818 47.1468 27.7918 49.6881 26.3012 52.3965C25.5724 53.7006 25.8043 55.339 26.8312 56.409L29.3487 58.9502L24.8106 63.5312L24.6118 63.3306C23.3199 62.0265 21.2331 62.0265 19.9412 63.3306C18.6493 64.6346 18.6493 66.7412 19.9412 68.0452L39.8162 88.1077C40.4787 88.7765 41.3068 89.0774 42.1681 89.0774C43.0293 89.0774 43.8574 88.743 44.5199 88.1077C45.8118 86.8037 45.8118 84.6971 44.5199 83.3931L44.3212 83.1924L48.8593 78.6115L50.2174 79.9824C50.8468 80.6177 51.7081 80.9521 52.5693 80.9521C53.1324 80.9521 53.6956 80.8184 54.1925 80.5174C56.8756 79.0127 59.3931 77.4077 61.7781 75.7359L62.9706 92.4881C63.07 93.7921 63.8981 94.929 65.1237 95.3971C65.4881 95.5309 65.8856 95.5977 66.2831 95.5977C67.1443 95.5977 68.0056 95.2634 68.6349 94.628L84.3362 78.7787C87.715 75.368 89.4706 70.6868 89.1393 65.9052L88.0131 48.0162L87.9468 47.9493ZM63.9643 65.5374L41.0749 42.4321C52.0724 29.1574 65.2562 21.2662 76.3531 16.5849L89.5368 29.8931C84.8993 41.0946 77.0818 54.4362 63.9312 65.504L63.9643 65.5374ZM92.1537 23.0384L83.21 13.9768C88.245 12.2715 92.4849 11.2684 95.4331 10.6999C94.8699 13.6424 93.8762 17.9559 92.1868 23.0384H92.1537ZM22.1274 37.3831L32.6943 26.7165C34.7149 24.6768 37.4643 23.6068 40.3462 23.8074L49.8862 24.4093C45.0168 28.3215 40.2468 32.9359 35.775 38.3862L22.0943 37.4165L22.1274 37.3831ZM39.5512 78.4109L29.4812 68.2459L34.0193 63.6649L44.0893 73.8299L39.5512 78.4109ZM52.9999 73.3952L33.2906 53.4999C34.4831 51.4937 35.7087 49.5877 37.0006 47.7821L58.6643 69.6502C56.8756 70.9543 54.9874 72.1915 52.9999 73.3952ZM79.5331 73.9971L68.9662 84.6637L68.0056 70.854C73.405 66.3734 77.9762 61.5249 81.8518 56.6096L82.4481 66.2396C82.6137 69.1152 81.5868 71.924 79.5662 73.9637L79.5331 73.9971Z" fill="#1B3964" />
    <path d="M74.7631 48.0495C76.9493 45.8426 78.1418 42.9001 78.1418 39.7904C78.1418 36.6808 76.9493 33.7383 74.7631 31.5314C70.3906 27.1176 62.7387 27.1176 58.3662 31.5314C56.1799 33.7383 54.9874 36.6808 54.9874 39.7904C54.9874 42.9001 56.1799 45.8426 58.3662 48.0495C60.5524 50.2564 63.4674 51.4936 66.5812 51.4936C69.6949 51.4936 72.5768 50.2898 74.7631 48.0495ZM70.0924 43.3348C68.2043 45.2408 64.9581 45.2408 63.0699 43.3348C62.1424 42.3986 61.6124 41.1279 61.6124 39.7904C61.6124 38.4529 62.1424 37.1823 63.0699 36.2461C63.9974 35.3098 65.2562 34.7748 66.5812 34.7748C67.9062 34.7748 69.1649 35.3098 70.0924 36.2461C71.0199 37.1823 71.5499 38.4529 71.5499 39.7904C71.5499 41.1279 71.0199 42.3986 70.0924 43.3348Z" fill="#1B3964" />
  </svg>
);

const ICONS = [GrowthIcon, OnlineBusinessIcon, RocketIcon];

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function Contactus() {
    return (
      <>
        <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
          <div className="row px-md-5">
            <div className="col-12 px-md-5">
              <div className="justify-content-md-between align-items-md-center">
                <h3 className="headerfont">Contact Us</h3>
                <div className="contentfonthead">
                  To speak with a Calque representative, call
                </div>
                <div className="contentfont">
                  <a
                    className="tel"
                    href={`tel:${props?.contactGlobal?.application_config_value}`}
                    style={{ cursor: "pointer", color: "black" }}
                  >
                    <b>{props?.contactGlobal?.application_config_value}</b>
                  </a>
                </div>
                <div className="contentfonthead">Or send an email to</div>
                <div className="contentfont">
                  <a
                    className="mailto"
                    href={`mailto:${props?.emailGlobal?.application_config_value}`}
                    style={{ cursor: "pointer", color: "black" }}
                  >
                    <b>{props?.emailGlobal?.application_config_value}</b>
                  </a>
                </div>
                <div className="contentfonthead">Our address is</div>
                <div className="contentfont">
                  <b>
                    <p className="contactAddress">
                      {props?.addressGlobal?.application_config_value}
                    </p>
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  function calqueMarket() {
    return (
      <>
        <form onSubmit={formik.handleSubmit} noValidate>
          <div className="container d-none d-md-block">
            <div className="row">
              <div className="col-6 p-5">
                <h2>WE'RE WORKING ON IT!</h2>
                <p className="pt-4">
                  Thanks for your interest in{" "}
                  {props?.partner?.partner_program_name}! Calque is not
                  currently operating in your market, but we’re expanding fast.
                </p>
                <p>
                  If you give us your name and email, we will reach out once we
                  arrive.
                </p>
              </div>
              <div className="col-6">
                <div className="col-12 top-padding-small py-3">
                  <h6>Name</h6>
                  <div className="row">
                    <div className="col-6">
                      <TextField
                        className="w-100"
                        placeholder="First Name"
                        type="text"
                        name="first_name"
                        onChange={formik.handleChange}
                        value={formik.values.first_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.first_name ? (
                          <div className="error-msg">
                            {formik.errors.first_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-6">
                      <TextField
                        className="w-100"
                        placeholder="Last Name"
                        name="last_name"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.last_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.last_name ? (
                          <div className="error-msg">
                            {formik.errors.last_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 py-3">
                  <h6>Email Address</h6>
                  <div className="row">
                    <div className="col-12">
                      <TextField
                        placeholder="Email"
                        variant="outlined"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        className="w-100"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.email ? (
                          <div className="error-msg">{formik.errors.email}</div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 py-3">
                  <div className="row">
                    <div className="col-12">
                      <Button
                        disableelevation="true"
                        type="submit"
                        variant="contained"
                        color="inherit"
                        className="w-100"
                        style={{ height: "50px", backgroundColor: "#FBC04E" }}
                        onClick={(e) => {
                          GAEventTracker("Submit Now(Non Operating Area)");
                          handlePopupSubmit(e);
                        }}
                      >
                        Submit Now
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container d-block d-md-none">
            <div>
              <div className="p-2">
                <h2>WE'RE WORKING ON IT!</h2>
                <p className="pt-4">
                  Thanks for your interest in{" "}
                  {props?.partner?.partner_program_name}! Calque is not
                  currently operating in your market, but we’re expanding fast.
                </p>
                <p>
                  If you give us your name and email, we will reach out once we
                  arrive.
                </p>
              </div>
              <div>
                <div className="top-padding-small py-3">
                  <h6>Name</h6>
                  <div>
                    <div>
                      <TextField
                        className="w-100"
                        placeholder="First Name"
                        type="text"
                        name="first_name"
                        onChange={formik.handleChange}
                        value={formik.values.first_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.first_name ? (
                          <div className="error-msg">
                            {formik.errors.first_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="pt-3">
                    <div>
                      <TextField
                        className="w-100"
                        placeholder="Last Name"
                        name="last_name"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.last_name}
                        variant="outlined"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.last_name ? (
                          <div className="error-msg">
                            {formik.errors.last_name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="py-3">
                  <h6>Email Address</h6>
                  <div>
                    <div>
                      <TextField
                        placeholder="Email"
                        variant="outlined"
                        name="email"
                        type="text"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        className="w-100"
                      />
                      {validateUserInfo === true ? (
                        formik.errors.email ? (
                          <div className="error-msg">{formik.errors.email}</div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="py-3">
                  <div>
                    <Button
                      disableelevation="true"
                      type="submit"
                      variant="contained"
                      color="inherit"
                      className="w-100"
                      style={{ height: "50px", backgroundColor: "#FBC04E" }}
                      onClick={(e) => {
                        GAEventTracker("Submit Now(Non Operating Area)");
                        handlePopupSubmit(e);
                      }}
                    >
                      Submit Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }

  return (
    <div className="inter">
      {/* <div className="col-12">
        <div className="row"> */}
          <div
            className="main-banner-img-container"
          >
            <div className="banner-left">
            <div className="banner-container">
              <h3
                className={`new-main-heading align-start inter banner-main-heading ${props?.partner?.url_path ==='megastar' ? 'custom-megastar-heading' :''}`}
                style={{
                  fontWeight: "bold",
                  color: "#000",
                  fontSize:props?.partner?.url_path ==='megastar' ? '55px': "55px",
                  marginBottom: "0px",
                }}
              >
                {props?.partner?.url_path === 'megastar' ? `Megastar's 7-Day`:'Buy And Sell'}
                <br />
                <span style={{ color: "#000" }}>{props?.partner?.url_path === 'megastar' ? 'Non-Contingent Buyer Program': 'With Confidence'}</span>
              </h3>
              <h4 className="second-heading">
                Move on your terms – Calque empowers <br /> you to buy your next home first before <br/> selling your current one.
              </h4>
              <div>
              <ApplicationFunnel />
            </div>
            <div>
              <p
                className="text-start m-0"
                style={{ fontSize: "18px", color: "#000000ff" }}
              >
                {/* *It's free and only takes 5 minutes! */}
                See if your home qualifies for a backup offer from Calque.
              </p>
            </div>
            </div>
          
            {/* LEFT CONTENT */}
          </div>

        <div className="banner-right">
          <div className="banner-image-blend">
            <img
              src="/assets/images/NewTempBannerThree.png"
              className="banner-figma-img"
              alt="House"
            />
          </div>
        </div>
            
          </div>
      
      <div style={{ padding: "80px 0px", width: "100%" }}>
      {/* HEADING */}
      <div style={{ textAlign: "center" }}>
        <h2 className="new-heading-one inter" style={{ fontWeight: "700" }}>
          <span style={{color: props.partner.secondary_color || "#2A83C2",}}>Transform Your Next Move </span>
           With Buy Before You Sell
        </h2>
      </div>

      {/* CARD GRID */}
      <div style={{ padding: "20px", alignSelf: "center" }}>
        <Grid container spacing={8} justifyContent="center" className="feature-grid">
          {[...Array(3)].map((_, i) => {
            const Icon = ICONS[i];

            return (
              <Grid key={i} item className="feature-item">
                <div className="banner-card">
                  {/* ICON */}
                  <div style={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                    <Icon />
                  </div>

                  {/* TITLE */}
                  <h4 className="inter card-heading" style={{ fontWeight: "bold", textAlign: "center" }}>
                    {["Strengthen Your Offer", "Buy with Certainty", "Sell on Your Terms"][i]}
                  </h4>

                  {/* DESCRIPTION */}
                  <p className="p-2 m-0 card-text" style={{ textAlign: "center", color:"black" }}>
                    {
                      [
                        "Say goodbye to missed opportunities – Calque turns your contingent offer into a winning one with a backup offer on your current home.",
                        "Move forward with Calque’s backup offer in your back pocket — giving you the freedom to buy your next home without waiting to sell your current one.",
                        "Stage, show, and sell your home after you’ve moved out to maximize value and minimize stress.",
                      ][i]
                    }
                  </p>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose1}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose1} severity={severity_type}>
          <div className="error" style={{ color: "white" }}>
            <span>{detail}</span>
          </div>
        </Alert>
      </Snackbar>
      <Modalpopup
        open={openSubmit}
        handleClickOpen={handleClickOpen2}
        contact={Contactus()}
      />
      <Modalpopupcalquemarket
        open={openCalque}
        handleClickOpener={handleClickOpener}
        contactData={calqueMarket()}
      />
      {props.cdrawerHome === false && (
        <CustomDrawer
          cdrawer={props.cdrawer}
          loader={props.loader}
          handleProgress={props.handleProgress}
          formik={props.formik}
          {...props}
          handleNext={props.handleNext}
          handleChange={props.handleChange}
          values={props.values}
          getEstimateButton={props.getEstimateButton}
          ValidateFinalError={props.ValidateFinalError}
          gaUserNotAnswered={props.gaUserNotAnswered}
          setGaUserNotAnswered={props.setGaUserNotAnswered}
          GAtimerFinish={props.GAtimerFinish}
          setCaptchaValue={props.setCaptchaValue}
          captchaValue={props.captchaValue}
          validateDisplay10={props.validateDisplay10}
        />
      )}
    </div>
  );
}
